document.documentElement.classList.remove('no-js');

(() => {
  const body = document.body;
  const scrim = document.querySelector('[data-drawer-scrim]');
  const cartDrawer = document.getElementById('CartDrawer');
  const menuDrawer = document.getElementById('MobileMenu');
  const searchDrawer = document.getElementById('SearchDrawer');

  const openPanel = (panel) => {
    if (!panel) return;
    closePanels();
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    scrim?.classList.add('visible');
    body.classList.add('drawer-open');
    panel.querySelector('input, button, a')?.focus();
  };

  const closePanels = () => {
    [cartDrawer, menuDrawer, searchDrawer].forEach((panel) => {
      panel?.classList.remove('open');
      panel?.setAttribute('aria-hidden', 'true');
    });
    scrim?.classList.remove('visible');
    body.classList.remove('drawer-open');
    document.querySelectorAll('[aria-expanded="true"]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
  };

  document.querySelectorAll('[data-open-cart]').forEach((button) => button.addEventListener('click', () => { button.setAttribute('aria-expanded', 'true'); openPanel(cartDrawer); refreshCart(); }));
  document.querySelectorAll('[data-open-menu]').forEach((button) => button.addEventListener('click', () => { button.setAttribute('aria-expanded', 'true'); openPanel(menuDrawer); }));
  document.querySelectorAll('[data-open-search]').forEach((button) => button.addEventListener('click', () => { button.setAttribute('aria-expanded', 'true'); openPanel(searchDrawer); }));
  document.querySelectorAll('[data-close-drawer], [data-close-search]').forEach((button) => button.addEventListener('click', closePanels));
  scrim?.addEventListener('click', closePanels);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

  const formatMoney = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

  const renderCart = (cart) => {
    const lines = document.querySelector('[data-cart-lines]');
    const summary = document.querySelector('[data-cart-summary]');
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-open-cart]').forEach((el) => {
      const label = el.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() || 'Cart';
      el.textContent = `${label} (${cart.item_count})`;
    });
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="empty-cart"><p>Your collection is waiting.</p><span>Add an artful object to begin.</span><a href="/collections/all" class="text-link">Shop all →</a></div>';
      summary?.classList.add('hidden');
      return;
    }
    lines.innerHTML = cart.items.map((item) => {
      const image = item.featured_image?.url ? `<img src="${escapeHtml(item.featured_image.url)}&width=184" alt="${escapeHtml(item.product_title)}" width="92" height="112">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : '';
      return `<article class="cart-line"><a href="${escapeHtml(item.url)}">${image}</a><div><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}<span>Qty ${item.quantity}</span></div><p>${formatMoney(item.final_line_price, cart.currency)}</p></article>`;
    }).join('');
    document.querySelector('[data-cart-subtotal]')?.replaceChildren(document.createTextNode(formatMoney(cart.total_price, cart.currency)));
    summary?.classList.remove('hidden');
  };

  async function refreshCart() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (response.ok) renderCart(await response.json());
    } catch (_) {}
  }

  async function addVariant(id, quantity = 1) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }) });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'This item could not be added.');
    }
    await refreshCart();
    openPanel(cartDrawer);
  }

  document.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.variantId, 1); }
    catch (error) { window.alert(error.message); }
    finally { button.disabled = false; }
  }));

  const normalizeCardImage = (image) => {
    const analyze = () => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      const size = 96;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      canvas.width = size;
      canvas.height = size;
      context.drawImage(image, 0, 0, size, size);
      let pixels;
      try { pixels = context.getImageData(0, 0, size, size).data; }
      catch (error) { return; }

      const corners = [0, size - 1, size * (size - 1), size * size - 1];
      const background = corners.reduce((color, index) => {
        const offset = index * 4;
        color[0] += pixels[offset];
        color[1] += pixels[offset + 1];
        color[2] += pixels[offset + 2];
        return color;
      }, [0, 0, 0]).map((channel) => channel / corners.length);

      let minX = size;
      let minY = size;
      let maxX = -1;
      let maxY = -1;
      for (let y = 0; y < size; y += 1) {
        for (let x = 0; x < size; x += 1) {
          const offset = (y * size + x) * 4;
          const red = pixels[offset] - background[0];
          const green = pixels[offset + 1] - background[1];
          const blue = pixels[offset + 2] - background[2];
          if (pixels[offset + 3] > 40 && red * red + green * green + blue * blue > 1296) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }
      if (maxX < minX || maxY < minY) return;

      const frame = image.parentElement?.getBoundingClientRect();
      if (!frame?.width || !frame.height) return;
      const sourceRatio = image.naturalWidth / image.naturalHeight;
      const frameRatio = frame.width / frame.height;
      const displayedWidth = sourceRatio > frameRatio ? 1 : sourceRatio / frameRatio;
      const displayedHeight = sourceRatio > frameRatio ? frameRatio / sourceRatio : 1;
      const subjectWidth = ((maxX - minX + 1) / size) * displayedWidth;
      const subjectHeight = ((maxY - minY + 1) / size) * displayedHeight;
      const scale = Math.max(.9, Math.min(1.55, .72 / subjectWidth, .78 / subjectHeight));
      image.style.setProperty('--product-card-scale', scale.toFixed(3));
    };

    const schedule = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(analyze, { timeout: 700 });
      else window.requestAnimationFrame(analyze);
    };
    if (image.complete) schedule();
    else image.addEventListener('load', schedule, { once: true });
  };
  document.querySelectorAll('[data-normalize-card-image]').forEach(normalizeCardImage);

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const data = root.querySelector('[data-product-variants]');
    if (!form || !data) return;
    const variants = JSON.parse(data.textContent);
    const optionInputs = [...root.querySelectorAll('[data-product-option]')];
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const errorNode = root.querySelector('[data-product-error]');
    const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
    const modelInput = optionInputs.find((input) => {
      const optionName = input.dataset.optionName || '';
      const optionValues = [...input.options].map((option) => option.value);
      return /model|device|phone/i.test(optionName) || optionValues.some((value) => /iphone|samsung|galaxy|pixel/i.test(value));
    });

    if (modelInput) {
      const groupOrder = new Map();
      const optionEntries = [...modelInput.options].map((option, index) => {
        const normalized = option.value.toLowerCase();
        let group = normalized.replace(/\d.*$/, '').replace(/[^a-z]+/g, ' ').trim();
        if (normalized.includes('iphone')) group = 'iphone';
        if (normalized.includes('samsung') || normalized.includes('galaxy')) group = 'samsung';
        if (normalized.includes('pixel')) group = 'pixel';
        if (!groupOrder.has(group)) groupOrder.set(group, groupOrder.size);
        const generation = Number(normalized.match(/\d+/)?.[0] || 0);
        return { option, index, group, generation };
      });

      optionEntries
        .sort((a, b) => groupOrder.get(a.group) - groupOrder.get(b.group) || b.generation - a.generation || a.index - b.index)
        .forEach(({ option }) => modelInput.append(option));

      if (!requestedVariantId) {
        const modelIndex = optionInputs.indexOf(modelInput);
        const newestAvailableOption = [...modelInput.options].find((option) => variants.some((variant) => variant.available && variant.options[modelIndex] === option.value));
        const defaultVariant = newestAvailableOption && variants.find((variant) => variant.available && variant.options[modelIndex] === newestAvailableOption.value);
        if (defaultVariant) {
          optionInputs.forEach((input, index) => {
            if ([...input.options].some((option) => option.value === defaultVariant.options[index])) input.value = defaultVariant.options[index];
          });
        }
      }
    }

    const updateVariant = () => {
      const selected = optionInputs.map((input) => input.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();

    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { const input = form.elements.quantity; input.value = Math.max(1, Number(input.value) - 1); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { const input = form.elements.quantity; input.value = Number(input.value) + 1; });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      addButton.disabled = true;
      errorNode.hidden = true;
      try { await addVariant(idInput.value, form.elements.quantity.value); }
      catch (error) { errorNode.textContent = error.message; errorNode.hidden = false; }
      finally { updateVariant(); }
    });
  });

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const frame = gallery.querySelector('.gallery-main');
    const buttons = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!frame || !buttons.length) return;
    const cache = new Map();
    let requested = 0;

    const prepare = (button, priority = 'low') => {
      const src = button.dataset.imageSrc;
      if (cache.has(src)) {
        const entry = cache.get(src);
        if (priority === 'high') entry.image.fetchPriority = 'high';
        return entry.ready;
      }
      const image = new Image();
      image.alt = button.dataset.imageAlt || '';
      image.decoding = 'async';
      image.fetchPriority = priority;
      const entry = { image, ready: null };
      entry.ready = new Promise((resolve, reject) => {
        image.onload = async () => {
          try { await image.decode(); } catch (_) {}
          resolve(image);
        };
        image.onerror = () => { cache.delete(src); reject(new Error('Gallery image unavailable')); };
        image.src = src;
      });
      cache.set(src, entry);
      return entry.ready;
    };

    const preload = () => buttons.forEach((button) => {
      if (!button.classList.contains('active')) prepare(button).catch(() => {});
    });
    const first = frame.querySelector('img');
    if (first?.complete) preload();
    else if (first) {
      first.addEventListener('load', preload, { once: true });
      first.addEventListener('error', preload, { once: true });
    }

    buttons.forEach((button) => {
      button.addEventListener('pointerenter', () => prepare(button, 'high').catch(() => {}));
      button.addEventListener('focus', () => prepare(button, 'high').catch(() => {}));
      button.addEventListener('click', async () => {
        const request = ++requested;
        frame.setAttribute('aria-busy', 'true');
        try {
          const image = await prepare(button, 'high');
          if (request !== requested) return;
          const current = frame.querySelector('img');
          if (!current) return;
          current.replaceWith(image);
          frame.classList.toggle('is-scene', button.dataset.imageScene === 'true');
          frame.style.setProperty('--media-ratio', String(Math.max(0.1, Number(button.dataset.imageRatio) || 1)));
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('active', active);
            if (active) item.setAttribute('aria-current', 'true');
            else item.removeAttribute('aria-current');
          });
        } catch (_) {
        } finally {
          if (request === requested) frame.removeAttribute('aria-busy');
        }
      });
    });
  });

  document.querySelectorAll('[data-open-filters]').forEach((button) => button.addEventListener('click', () => document.querySelector('[data-filters-panel]')?.classList.add('open')));
  document.querySelectorAll('[data-close-filters]').forEach((button) => button.addEventListener('click', () => document.querySelector('[data-filters-panel]')?.classList.remove('open')));
  document.querySelectorAll('[data-sort-select], [data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (!section.dataset.url) return;
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (_) {}

  });

  document.querySelectorAll('[data-world-selector]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-world-card]')];
    const controls = [...root.querySelectorAll('[data-world-control]')];
    const stage = root.querySelector('[data-world-stage]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (cards.length < 2) return;

    let active = 0;
    let hovered = null;
    let timer;
    let pointerInside = false;
    let edgeTimer;
    let edgeDirection = 0;

    const getSlot = (index, center) => {
      let slot = (index - center + cards.length) % cards.length;
      if (slot > cards.length / 2) slot -= cards.length;
      return slot;
    };

    const render = () => {
      const center = hovered ?? active;
      cards.forEach((card, index) => {
        const slot = getSlot(index, center);
        card.dataset.slot = slot;
        card.classList.toggle('is-active', slot === 0);
      });
      controls.forEach((control, index) => {
        const selected = index === center;
        control.classList.toggle('active', selected);
        control.setAttribute('aria-pressed', String(selected));
      });
    };

    const startTimer = () => {
      window.clearInterval(timer);
      if (reduceMotion) return;
      timer = window.setInterval(() => {
        if (hovered !== null || pointerInside || document.hidden || document.querySelector('dialog[open]')) return;
        active = (active + 1) % cards.length;
        render();
      }, 4200);
    };

    cards.forEach((card, index) => {

      card.addEventListener('focusin', () => { hovered = index; render(); });
      card.addEventListener('focusout', () => { hovered = null; render(); });
      card.addEventListener('pointerdown', (event) => {
        if ((event.pointerType === 'touch' && window.matchMedia('(max-width:800px)').matches) || card.classList.contains('is-active') || event.target.closest('a')) return;
        active = index;
        hovered = null;
        render();
        startTimer();
      });
    });

    const handleWorldHover = (event) => {
      if (event.pointerType !== 'mouse') return;
      pointerInside = true;
      const bounds = root.getBoundingClientRect();
      const position = (event.clientX - bounds.left) / bounds.width;
      const direction = position < 0.26 ? -1 : position > 0.74 ? 1 : 0;
      if (!direction) {
        window.clearTimeout(edgeTimer);
        edgeDirection = 0;
        return;
      }
      if (event.target.closest('button,input,.world-gate-head,.world-controls')) {
        window.clearTimeout(edgeTimer);
        edgeDirection = 0;
        return;
      }
      if (edgeDirection === direction) return;
      window.clearTimeout(edgeTimer);
      edgeDirection = direction;
      const advanceWorld = () => {
        if (!pointerInside || edgeDirection !== direction || document.hidden || document.querySelector('dialog[open]')) {
          edgeDirection = 0;
          return;
        }
        active = (active + direction + cards.length) % cards.length;
        hovered = null;
        render();
        startTimer();
        edgeTimer = window.setTimeout(advanceWorld, 700);
      };
      edgeTimer = window.setTimeout(advanceWorld, 180);
    };
    root.addEventListener('pointerenter', handleWorldHover);
    root.addEventListener('pointermove', handleWorldHover);
    root.addEventListener('pointerleave', () => {
      pointerInside = false;
      edgeDirection = 0;
      window.clearTimeout(edgeTimer);
      hovered = null;
      render();
      startTimer();
    });
    controls.forEach((control, index) => control.addEventListener('click', () => {
      active = index;
      hovered = null;
      render();
      startTimer();
    }));
    root.querySelector('[data-world-previous]')?.addEventListener('click', () => {
      active = (active - 1 + cards.length) % cards.length;
      hovered = null;
      render();
      startTimer();
    });
    root.querySelector('[data-world-next]')?.addEventListener('click', () => {
      active = (active + 1) % cards.length;
      hovered = null;
      render();
      startTimer();
    });

    let gesture = null;
    let suppressClickUntil = 0;
    stage?.addEventListener('touchstart', event => {
      if (!window.matchMedia('(max-width:800px)').matches) return;
      if (event.touches.length !== 1) { gesture = null; return; }
      const touch = event.touches[0];
      gesture = { x:touch.clientX, y:touch.clientY, dx:0, dy:0, horizontal:false };
      window.clearInterval(timer);
    }, { passive:true });
    stage?.addEventListener('touchmove', event => {
      if (!gesture || event.touches.length !== 1) { gesture = null; return; }
      const touch = event.touches[0];
      gesture.dx = touch.clientX - gesture.x;
      gesture.dy = touch.clientY - gesture.y;
      if (Math.abs(gesture.dy) > 12 && Math.abs(gesture.dy) > Math.abs(gesture.dx)) {
        gesture = null;
        startTimer();
        return;
      }
      if (Math.abs(gesture.dx) > 12 && Math.abs(gesture.dx) > Math.abs(gesture.dy) * 1.3) {
        gesture.horizontal = true;
        if (event.cancelable) event.preventDefault();
      }
    }, { passive:false });
    stage?.addEventListener('touchend', () => {
      if (gesture?.horizontal) {
        suppressClickUntil = Date.now() + 450;
        if (Math.abs(gesture.dx) >= 40) {
          active = (active + (gesture.dx < 0 ? 1 : -1) + cards.length) % cards.length;
          hovered = null;
          render();
        }
      }
      gesture = null;
      startTimer();
    }, { passive:true });
    stage?.addEventListener('touchcancel', () => { gesture = null; startTimer(); }, { passive:true });
    stage?.addEventListener('click', event => {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);

    render();
    startTimer();
  });

  let touchPreview = null;
  let previewTimer;
  const clearPreview = () => {
    touchPreview?.classList.remove('is-touch-preview');
    touchPreview = null;
  };
  document.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'touch' || !window.matchMedia('(max-width:800px)').matches) return;
    clearTimeout(previewTimer);
    clearPreview();
    const card = event.target.closest('.product-card');
    if (!card?.querySelector('.product-image.has-scene')) return;
    touchPreview = card;
    card.classList.add('is-touch-preview');
  }, { passive:true });
  const finishPreview = () => { clearTimeout(previewTimer); previewTimer = setTimeout(clearPreview, 1400); };
  document.addEventListener('pointerup', finishPreview, { passive:true });
  document.addEventListener('pointercancel', finishPreview, { passive:true });
})();





